import { CheckboxGroup, CheckboxGroupProps } from "@heroui/react";
import { MantineFormValues } from "./shared.types";
import React from "react";

type CheckboxGroup = MantineFormValues & CheckboxGroupProps;

export const LimeCheckboxGroup = React.forwardRef(
  ({ error, ...props }: CheckboxGroup, ref: React.Ref<HTMLInputElement>) => (
    <CheckboxGroup
      ref={ref}
      errorMessage={error}
      isInvalid={!!error}
      {...props}
    />
  ),
);
LimeCheckboxGroup.displayName = "LimeCheckboxGroup";
